import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import {
  Grid,
  Header,
  Container,
  Image,
  Button,
  Icon,
} from 'semantic-ui-react';

import { ClassProp } from 'helpers/types';

const styles = {
  reportName: {
    marginRight: '1rem !important',
  },
  downloadButton: {
    margin: '1rem 0 0 .5rem !important',
  },
};

type Props = {
  classes: ClassProp<typeof styles>;
  name: string;
  imageURL?: string;
};

const ValidReport: FunctionComponent<Props> = ({ classes, imageURL, name }) => (
  <Grid.Column key={name} textAlign="left" width={8}>
    <Header as="h5" className={classes.reportName}>
      {name}
    </Header>

    <Container>
      <Image src={imageURL} size="small" />
    </Container>

    <Button
      className={classes.downloadButton}
      as="a"
      href={imageURL}
      download={`${name}.png`}
      icon
    >
      <Icon name="cloud download" />
    </Button>
  </Grid.Column>
);

export default withStyles(styles)(ValidReport);
